import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'ProductDesignItem',
    column_type: 'id',
    label_key_path: 'productDesignItem.id',
  },
  created_at: {
    model_name: 'ProductDesignItem',
    column_type: 'datetime',
    label_key_path: 'productDesignItem.createdAt',
  },
  updated_at: {
    model_name: 'ProductDesignItem',
    column_type: 'datetime',
    label_key_path: 'productDesignItem.updatedAt',
  },
  quantity: {
    model_name: 'ProductDesignItem',
    column_type: 'integer',
    label_key_path: 'productDesignItem.quantity',
  },
  color_option_value: {
    model_name: 'ProductDesignItem',
    column_type: 'belongs_to',
    label_key_path: 'productDesignItem.colorOptionValue',
    extra: {
      association_name: 'color_option_value',
      model_name: 'OptionValue',
      foreign_key: 'color_option_value_id',
      display_column: 'name',
    },
  },
  color_option_value_id: {
    model_name: 'ProductDesignItem',
    column_type: 'belongs_to',
    label_key_path: 'productDesignItem.colorOptionValue',
    extra: {
      association_name: 'color_option_value',
      model_name: 'OptionValue',
      foreign_key: 'color_option_value_id',
      display_column: 'name',
    },
  },
  size_option_value: {
    model_name: 'ProductDesignItem',
    column_type: 'belongs_to',
    label_key_path: 'productDesignItem.sizeOptionValue',
    extra: {
      association_name: 'size_option_value',
      model_name: 'OptionValue',
      foreign_key: 'size_option_value_id',
      display_column: 'name',
    },
  },
  size_option_value_id: {
    model_name: 'ProductDesignItem',
    column_type: 'belongs_to',
    label_key_path: 'productDesignItem.sizeOptionValue',
    extra: {
      association_name: 'size_option_value',
      model_name: 'OptionValue',
      foreign_key: 'size_option_value_id',
      display_column: 'name',
    },
  },
  color: {
    model_name: 'ProductDesignItem',
    column_type: 'string',
    label_key_path: 'productDesignItem.color',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
